import defaultOptions from "config/projector_defaults.json";

export function getConfig(): object {
    return JSON.parse(JSON.stringify(defaultOptions));
}

export function isIndexExchangeEnabled(): boolean {
    return defaultOptions.useIndexExchange;
}
